import { Injectable } from '@angular/core';
import {AngularFirestore, AngularFirestoreDocument} from '@angular/fire/firestore';
import {Observable} from 'rxjs';
import {map} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class FirestoreService {

  constructor(
      private afs: AngularFirestore
  ) { }

  public getOneWatcher<T>(collection: string, uid: string): Observable<any> {
    return this.afs.doc<T>(`${collection}/${uid}`).valueChanges();
  }

  public get(path: string): Promise<AngularFirestoreDocument<{}>> {
    return new Promise(resolve => {
      resolve(this.afs.doc(path));
    });
  }

  

  public update<T>(collection: string, uid: string, document): Promise<any> {
    return this.afs.doc<T>(`${collection}/${uid}`).update(document);
  }

  public save<T>(collection: string, document): Promise<any> {
    document.uid = document.uid != null && document.uid != '' && document.uid != undefined ? document.uid : this.afs.createId();
    return this.afs.doc<T>(`${collection}/${document.uid}`).set(document);
  }

  public getWhere_old<T>(collection: string, key: string, value: any): Observable<any> {
    return this.afs.collection<T>(collection, ref => ref.where(key, '==', value)).valueChanges();
  }

  public getWhere<T>(collection: string, key: string, value: any): Observable<any> {
    return this.afs.collection<T>(collection, ref => ref.where(key, '==', value)).snapshotChanges().pipe(
        map(actions => {
          return actions.map(a => {
            const data = a.payload.doc.data() as T;
            const id = a.payload.doc.id;
            return { id, ...data };
          });
        })
    );
  }

  // Agrega este método en tu FirestoreService (firestore.service.ts)

/**
 * Busca una orden por uid o orderId
 * Intenta múltiples estrategias para encontrar el documento
 */
// Agrega este método en tu FirestoreService (firestore.service.ts)

/**
 * Busca una orden por uid o orderId
 * Intenta múltiples estrategias para encontrar el documento
 * NOTA: La colección se llama "Orders" con mayúscula
 */
public getOrderByUid(orderUid: string): Observable<any> {
  return new Observable(observer => {
    const collectionName = 'Orders'; // ← Nombre correcto con mayúscula
    
    // Estrategia 1: Buscar directamente por ID del documento
    this.afs.doc(`${collectionName}/${orderUid}`).get().subscribe({
      next: (docSnapshot) => {
        if (docSnapshot.exists) {
          const data = docSnapshot.data();
          //console.log('✓ Orden encontrada por ID documento');
          observer.next({ id: docSnapshot.id, ...data });
          observer.complete();
        } else {
          // Estrategia 2: Buscar por campo 'uid'
          //console.log('No encontrado por ID, buscando por campo uid...');
          this.afs.collection(collectionName, ref => ref.where('uid', '==', orderUid).limit(1))
            .get()
            .subscribe({
              next: (querySnapshot) => {
                if (!querySnapshot.empty) {
                  const doc = querySnapshot.docs[0];
                  //console.log('✓ Orden encontrada por campo uid');
                  observer.next({ id: doc.id, ...doc.data() });
                  observer.complete();
                } else {
                  // Estrategia 3: Buscar por campo 'orderId'
                  //console.log('No encontrado por uid, buscando por campo orderId...');
                  this.afs.collection(collectionName, ref => ref.where('orderId', '==', orderUid).limit(1))
                    .get()
                    .subscribe({
                      next: (querySnapshot2) => {
                        if (!querySnapshot2.empty) {
                          const doc = querySnapshot2.docs[0];
                          //console.log('✓ Orden encontrada por campo orderId');
                          observer.next({ id: doc.id, ...doc.data() });
                          observer.complete();
                        } else {
                          console.error('Orden no encontrada en ninguna búsqueda');
                          observer.next(null);
                          observer.complete();
                        }
                      },
                      error: (err) => {
                        console.error('Error buscando por orderId:', err);
                        observer.error(err);
                      }
                    });
                }
              },
              error: (err) => {
                console.error('Error buscando por uid:', err);
                observer.error(err);
              }
            });
        }
      },
      error: (err) => {
        console.error('Error buscando por ID documento:', err);
        observer.error(err);
      }
    });
  });
}



  public getOne(collection: string, uid: string) {
    return this.afs.doc(`${collection}/${uid}`).valueChanges();
  }

 public getOneOnce<T>(collection: string, uid: string): Promise<T | undefined> {
  return new Promise((resolve, reject) => {
    this.afs.doc<T>(`${collection}/${uid}`).get().subscribe({
      next: (docSnap) => {
        if (docSnap.exists) {
          resolve(docSnap.data() as T);
        } else {
          resolve(undefined);
        }
      },
      error: (err) => {
        console.error('Error getting document once:', err);
        reject(err);
      }
    });
  });
}

  

  public getSubcollectionDocumentsWithFilter<T>(parentCollection: string, parentId: string, subcollection: string, filterKey: string, filterValue: any): Observable<any> {
    return this.afs.collection(parentCollection).doc(parentId).collection(subcollection, ref => ref.where(filterKey, '==', filterValue)).snapshotChanges().pipe(
        map(actions => {
          return actions.map(a => {
            const data = a.payload.doc.data() as T;
            const uid = a.payload.doc.id;
            return { uid, ...data };
          });
        })
    );
  }

  public getWhereSubcollection<T>(parentCollection: string, subcollection: string, key: string, value: any): Observable<any> {
    return this.afs.collection(parentCollection).doc(subcollection).collection<T>(subcollection, ref => ref.where(key, '==', value)).snapshotChanges().pipe(
        map(actions => {
          return actions.map(a => {
            const data = a.payload.doc.data() as T;
            const uid = a.payload.doc.id;
            return { uid, ...data };
          });
        })
    );
  }

  public getSubcollectionWhere<T>(parentCollection: string, subcollection: string, idsubcollection: string, key: string, value: any): Observable<any> {
    return this.afs.collection(parentCollection).doc(idsubcollection).collection(subcollection, ref => ref.where(key, '==', value)).snapshotChanges().pipe(
        map(actions => {
          return actions.map(a => {
            const data = a.payload.doc.data() as T;
            const uid = a.payload.doc.id;
            return { uid, ...data };
          });
        })
    );
  }

  public getDocument<T>(path: string): Observable<T> {
    return this.afs.doc<T>(path).valueChanges();
  }

  public createID(){
    return this.afs.createId();
  }

  public saveSubcollection<T>(collection: string, docID: string, subcollection: string, subdocID: string, document: T): Promise<void> {
    if (!docID || docID == '') {
      docID = this.afs.createId();
    }
    return this.afs.collection(collection).doc(docID).collection(subcollection).doc(subdocID).set(document, { merge: true });
  }



  public search(collectionName, objectSearch) {

    /*
      After applying these query you may face this error:
      "ERROR FirebaseError: The query requires an index. You can create it here: URL"
      You will get above error with an URL - Click over that URL - Login in Firebase
      and this will prompt to Create an Index which is required in Firebase
      to apply queries to Database Collection.
    */
    return this.afs.collection(collectionName, ref => {
      let query: firebase.firestore.CollectionReference | firebase.firestore.Query = ref;
      // for (const prop in objectSearch) { query = query.where(`${prop}`, '==', `${objectSearch[prop]}`); }
      if (objectSearch.phone) {
        //console.log('objectSearch.phone ' + objectSearch.phone);
        query = query.where('phone', '==', objectSearch.phone);
      }
      if (objectSearch.locations_uid) {
        //console.log('objectSearch.locations_uid ' + objectSearch.locations_uid);
        query = query.where('locations_uid', '==', objectSearch.locations_uid);
      }
      if (objectSearch.commerce_uid && objectSearch.commerce_uid != '' && objectSearch.commerce_uid != undefined) {
        query = query.where('commerce_uid', '==', objectSearch.commerce_uid);
      }
      if (objectSearch.orders_status_uid && objectSearch.orders_status_uid != '' && objectSearch.orders_status_uid != undefined) {
        query = query.where('orders_status_uid', '==', objectSearch.orders_status_uid);
      }
      if (objectSearch.manager_user_uid && objectSearch.manager_user_uid != '' && objectSearch.manager_user_uid != undefined) {
        query = query.where('manager_user_uid', '==', objectSearch.manager_user_uid);
      }
      if (objectSearch.user_uid && objectSearch.user_uid != '' && objectSearch.user_uid != undefined) {
        query = query.where('user_uid', '==', objectSearch.user_uid);
      }
      if (objectSearch.category_uid) {
        query = query.where('category_uid', '==', objectSearch.category_uid);
      }
      if (objectSearch.joinDate) {
        objectSearch.joinDateTimestamp = new Date(objectSearch.joinDate);
        query = query.where('joinDateTimestamp', '==', objectSearch.joinDateTimestamp);
      }
      if (objectSearch.name) {
        query = query.where('name', '>=', objectSearch.name);
        query = query.where('name', '<=', objectSearch.name + '\uf8ff');
      }
      if (objectSearch.limit) {
        query = query.limit(objectSearch.limit);
      }
      if (objectSearch.orderByName) {
        query = query.orderBy(objectSearch.orderByName, objectSearch.orderByDir);
      }

      return query;
    }).snapshotChanges();
  }

  public getAll<T>(collection: string): Observable<any> {
    return this.afs.collection<T>(collection).valueChanges();
  }
}
